// import { Box, Grid, useMediaQuery } from "@mui/material";
// import { motion, AnimatePresence } from "framer-motion";
// import React, { useState, useEffect } from "react";
// import { fetchData } from "../../BaseUrl"; // Ensure this function is correct

// function Banner() {
//   const isMobile = useMediaQuery("(max-width:912px)");

//   const styles = {
//     container: {
//       paddingTop: isMobile ? "4rem" : "6rem",
//       width: "100vw",
//       height: "100vh",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       overflow: "hidden",
//       position: "relative",
//       backgroundColor: "#F7F3FC",
//     },
//     imageWrapper: {
//       width: "100vw",
//       height: "100vh",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       position: "relative",
//       borderRadius: "15px",
//       overflow: "hidden",
//     },
//     image: {
//       width: "90%",
//       height: "90%",
//       objectFit: "cover",
//       objectPosition: "center",
//       position: "absolute",
//       borderRadius: "15px",
//     },
//     dotsContainer: {
//       position: "absolute",
//       bottom: "10px",
//       left: "50%",
//       transform: "translateX(-50%)",
//       display: "flex",
//       gap: "8px",
//     },
//     dot: (active) => ({
//       width: "12px",
//       height: "12px",
//       borderRadius: "50%",
//       backgroundColor: active ? "#244C77" : "#D3D3D3",
//       transition: "background-color 0.5s ease-in-out",
//     }),
//   };

//   const [images, setImages] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   useEffect(() => {
//     getImage();
//   }, []);

//   const getImage = async () => {
//     try {
//       const response = await fetchData("/admin/event/list");
//       if (response?.data?.length) {
//         setImages(response.data.map((item) => item.imageUrl));
//       } else {
//         setImages([]);
//       }
//     } catch (error) {
//       console.error("Error fetching data: ", error);
//       setImages([]);
//     }
//   };

//   useEffect(() => {
//     if (images.length > 0) {
//       const interval = setInterval(() => {
//         setCurrentIndex((prev) => (prev + 1) % images.length);
//       }, 3000);

//       return () => clearInterval(interval);
//     }
//   }, [images]);

//   return (
//     <Box sx={styles.container}>
//       <Grid container justifyContent="center" alignItems="center">
//         <Grid item xs={12} sx={styles.imageWrapper}>
//           <AnimatePresence>
//             {images.length > 0 && (
//               <motion.img
//                 key={currentIndex}
//                 src={images[currentIndex]}
//                 alt="banner"
//                 style={styles.image}
//                 initial={{ opacity: 0, x: 100 }} // Slide in from right
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -100 }} // Slide out to left
//                 transition={{ duration: 1, ease: "easeInOut" }}
//               />
//             )}
//           </AnimatePresence>
//         </Grid>
//       </Grid>

//       {/* Pagination Dots */}
//       {images.length > 0 && (
//         <Box sx={styles.dotsContainer}>
//           {images.map((_, index) => (
//             <Box key={index} sx={styles.dot(currentIndex === index)} />
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// }

// export default Banner;

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import React, { useState, useEffect, useRef, useCallback } from "react";
import tamil1 from "../../Assest/Images/tamil1.jpg";
import tamil2 from "../../Assest/Images/tamil2.jpg";
import tamil3 from "../../Assest/Images/tamil3.jpg";
import banner1 from '../../Assest/Images/bannerImageUpdateNew.png'
import colors from "../../Assest/Theme/Color";
import { fetchData } from "../../BaseUrl";
import Routings from "../../Routings";

import {
  Close as CloseIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const data = [
  {
    id: 1,
    name: "Annual Science Fair",
    imageUrl: banner1,
  },
  {
    id: 2,
    name: "Annual Science Fair 2025",
    imageUrl: tamil1,
  },
  {
    id: 3,
    name: "Tech Innovation Day 2025",
    imageUrl: tamil2,
  },
  {
    id: 4,
    name: "Environmental Awareness Expo",
    imageUrl: tamil3,
  },
  // {
  //   id: 5,
  //   name: "Coding Challenge Marathon",
  //   imageUrl: tamil4,
  // },
];

function Banner() {
  const isMobile = useMediaQuery("(max-width:912px)");
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [images, setImages] = useState(data);
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const navigate = useNavigate();

  // Admin-managed home carousel (home-config). Falls back to the static `data`
  // above when no content has been configured yet.
  useEffect(() => {
    fetchData("admin/home-config/list")
      .then((res) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        const slides = rows
          .filter((r) => r.imageUrl)
          .map((r) => ({ id: r.id, name: r.title || "", imageUrl: r.imageUrl }));
        if (slides.length) setImages(slides);
      })
      .catch(() => {/* keep static fallback */ });
  }, []);

  const styles = {
    container: {
      paddingTop: isMobile ? "4rem" : "6rem",
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      position: "relative",
      backgroundColor: "#F7F3FC",
    },
    imageWrapper: {
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      borderRadius: "15px",
      overflow: "hidden",
    },
    image: {
      width: "90%",
      height: "90%",
      objectFit: currentIndex === 0 ? "" : "",
      objectPosition: "center",
      position: "absolute",
      borderRadius: "15px",
    },
    dotsContainer: {
      position: "absolute",
      bottom: "10px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: "8px",
      zIndex: 3,
    },
    dot: (active) => ({
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      backgroundColor: active ? "#244C77" : "#D3D3D3",
      transition: "background-color 0.5s ease-in-out",
    }),
  };

  const startAutoScroll = useCallback(() => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % data.length);
    }, 3000);
  }, []);

  const stopAutoScroll = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    startAutoScroll();
    return () => stopAutoScroll();
  }, [startAutoScroll, stopAutoScroll]);

  const handleredirecturl = (url) => {
    window.open(url, "_blank")
  }

  return (
    <Box sx={styles.container}>
      <Dialog
        open={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <IconButton
          onClick={() => setRegisterModalOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8, color: "#9CA3AF" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "20px", color: "#3B4E8C", pt: 4, lineHeight: 1.4 }}>
          Are you a new student<br />or an existing student?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", color: "#6B7280", fontSize: "14px" }}>
            Please select an option to continue your registration.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            variant="contained"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "new" },
              });
            }}
            sx={{
              backgroundColor: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#2d3d6e" },
            }}
          >
            New Student
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "old" },
              });
            }}
            sx={{
              borderColor: "#3B4E8C",
              color: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#f0f2f8" },
            }}
          >
            Existing Student
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          item
          xs={12}
          sx={styles.imageWrapper}
          onMouseEnter={stopAutoScroll}
          onMouseLeave={startAutoScroll}
        >
          <AnimatePresence>
            {images.length > 0 && images[currentIndex] && (
              <motion.img
                key={currentIndex}
                src={images[currentIndex].imageUrl}
                alt="banner"
                style={styles.image}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 1, ease: "easeInOut" }}
              />
            )}
          </AnimatePresence>

          {/* Register Now Button - only on first banner */}
          {currentIndex === 0 && (
            <Box
              sx={{
                position: "absolute",
                bottom: isMobile ? "60px" : "60px",
                left: isMobile ? "50%" : "13%",
                transform: "translateX(-50%)",
                zIndex: 2,
              }}
            >
              <button
                style={{
                  padding: "10px 10px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  backgroundColor: "#244C77",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}
                onClick={() => setRegisterModalOpen(true)}
              >
                Register Now
              </button>
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Pagination Dots */}
      {
        images.length > 0 && (
          <Box sx={styles.dotsContainer}>
            {images.map((_, index) => (
              <Box
                key={index}
                sx={{
                  ...styles.dot(currentIndex === index),
                  cursor: "pointer",

                }}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </Box>
        )
      }
    </Box >
  );
}

export default Banner;
